import { render, staticRenderFns } from "./tab-widget.vue?vue&type=template&id=b02f4068&scoped=true&"
import script from "./tab-widget.vue?vue&type=script&lang=js&"
export * from "./tab-widget.vue?vue&type=script&lang=js&"
import style0 from "./tab-widget.vue?vue&type=style&index=0&id=b02f4068&prod&lang=css&"
import style1 from "./tab-widget.vue?vue&type=style&index=1&id=b02f4068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02f4068",
  null
  
)

export default component.exports